/* eslint-disable no-unused-vars */
import {
  Button,
  Grid,
  IconButton,
  Typography,
  Avatar,
  Dialog,
  CircularProgress,
  ToggleButtonGroup,
  ToggleButton,
} from "@mui/material";
import { green, purple } from "@mui/material/colors";

import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Store } from "../../utils/Store";
import { styled } from "@mui/material/styles";
import MScreen from "./MScreen";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";

import Link from "@mui/material/Link";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { AgentUtils } from "../../utils/AgentUtils";
import BarcodeReader from "react-barcode-reader";
import API from "../../utils/API";

const theme = createTheme();

export default function PAuthenticationWindow(props) {
  const { t } = useTranslation();
  const translate = t;

  const [loading, setLoading] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");

  const [userNameError, setUserNameError] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    // eslint-disable-next-line no-console
    console.log({
      userName: data.get("userName"),
      password: data.get("password"),
    });

    checkLogin(new FormData(event.currentTarget));
  };

  async function onBarcodeScanned(barcode) {
    try {
      setLoading(true);
      console.log("Scuccess Barcode :", barcode);
      let { data } = await API.post("/auth/v1/users/signinwithcard", {
        code: barcode,
      });
      props.handleLoginSucessResponse(data.accessToken);
      props.showWindow(false);
    } catch (erro) {
      console.log(erro);
      setErrorMessage(translate("Login failed."));
    }
    setLoading(false);
  }

  function rejectdBarcode(barcode) {
    console.log("Failure Barcode :", barcode);
  }

  async function checkLogin(form) {
    setErrorMessage("");
    try {
      if (!validate(form)) {
        return;
      }
      setLoading(true);
      console.log("Real Loggin");
      const response = await fetch(
        (await AgentUtils.getBaseUrl()) + "/auth/v1/users/signin",
        {
          method: "post",
          body: JSON.stringify({
            username: form.get("userName"),
            password: form.get("password"),
            shopCode: localStorage.getItem("w_shopCode"),
          }),
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        const json = await response.json();

        /*API.defaults.headers.common = {
          Authorization: `Bearer ${json.refreshToken}`,
          baseURL: props.baseUrl,
        };*/

        props.handleLoginSucessResponse(json.accessToken);
        props.showWindow(false);

        setLoading(false);
        //TODO
      } else if (response.status === 500) {
        setErrorMessage(translate("Login failed. Can not contact Server..."));
        setLoading(false);
      } else {
        setErrorMessage(translate("Invalid Credentials..."));
        setLoading(false);
      }
    } catch (e) {
      setErrorMessage(translate("Invalid Credentials..."));
      setLoading(false);
      console.log(e);
    }
  }

  function validate(form) {
    let flag = true;
    setUserNameError("");
    setPasswordError("");

    if (!form.get("userName") || form.get("userName") == "") {
      setUserNameError(translate("User Name Required"));
      flag = false;
    }
    if (!form.get("password") || form.get("password") == "") {
      setPasswordError(translate("Password Required"));
      flag = false;
    }
    return flag;
  }

  let content = (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs" style={{ height: "400px" }}>
        <CssBaseline />
        <Box
          sx={{
            paddingTop: "10px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            {translate("Sign In")}
          </Typography>
          <Box
            component="form"
            onSubmit={handleSubmit}
            noValidate
            sx={{ mt: 1 }}
          >
            <TextField
              margin="normal"
              required
              fullWidth
              id="userName"
              label={translate("User Name")}
              name="userName"
              autoComplete="userName"
              autoFocus={
                props.context.storeAdmin.switchUserWithCard ? false : true
              }
            />
            <Typography variant="caption">{userNameError}</Typography>

            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label={translate("Password")}
              type="password"
              id="password"
              autoComplete="current-password"
            />
            <Typography variant="caption">{passwordError}</Typography>

            <Typography variant="caption">{errorMessage}</Typography>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              disabled={loading}
            >
              {loading && <CircularProgress size={20} />}
              {translate("Sign In")}
            </Button>
          </Box>
        </Box>
      </Container>
    </ThemeProvider>
  );

  function handleClose() {}

  return (
    <Dialog open={true} onClose={handleClose}>
      {props.context.storeAdmin.switchUserWithCard && (
        <BarcodeReader
          onError={rejectdBarcode}
          onScan={onBarcodeScanned}
          avgTimeByChar={
            props.context.storeAdmin.barcodeScanAvgTimeByChar
              ? props.context.storeAdmin.barcodeScanAvgTimeByChar
              : 30
          }
        />
      )}
      <MScreen
        dialogMode={true}
        maxWidth={"sm"}
        position={props.context.appMode === "desktop-pos" ? "static" : "fixed"}
        title={translate("Authenticate")}
        isMoreMenuEnabled={false}
        onRedirectToBack={() => {
          props.showWindow(false);
        }}
        content={content}
        //dialogeSideMenuOptions={getSideMenu()}
        //onLogOut={props.onLogOut}
      ></MScreen>
    </Dialog>
  );
}
